<template>
  <module-box
    type="character-info"
    :mode="mode"
    :moduleData="moduleData"
    @onAdd="handleAddModule"
    @onDelete="handleDeleteModule"
    @onMore="handleMore"
  >
    <div class="character-info">
      <module-title :mode="mode" :title="moduleData.title" @onChange="handleTitleChange"></module-title>
      <div class="container">
        <template v-if="moduleData.infoList.length > 0">
          <draggable
            v-for="(list, gIndex) in groupInfoList"
            :key="gIndex"
            class="group-container"
            v-model="groupInfoList[gIndex]"
            :animation="200"
            :group="'characterInfoList'"
            :disabled="mode !== 'edit'"
            :ghostClass="'ghost'"
            :handle="'.edit-drag'"
            @start="dragInfo = true"
            @end="dragInfo = false"
            @change="handleSortInfo"
          >
            <div v-for="data in list" :key="data.key" class="item-box">
              <info-box
                :mode="mode"
                :data="data"
                @onAdd="handleAddInfo(data.key)"
                @onDelete="handleDeleteInfo(data.key)"
                @onChange="data => handleInfoChange(data.key, data)"
              ></info-box>
            </div>
          </draggable>
        </template>
        <template v-else-if="mode == 'edit'">
          <button class="add-btn" @click.stop="handleAddInfo">
            <i class="icon wiki-editable-add"></i>
          </button>
        </template>
      </div>
    </div>
  </module-box>
</template>

<script>
import draggable from "vuedraggable";
// components
import ModuleBox from "../../components/ModuleBox";
import InfoBox from "./components/InfoBox";
import ModuleTitle from "../../components/ModuleTitle";

export default {
  name: "CharacterInfo",
  components: {
    draggable,
    ModuleBox,
    InfoBox,
    ModuleTitle
  },
  props: {
    mode: String,
    moduleData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dragInfo: false,
      groupInfoList: []
    };
  },
  watch: {
    moduleData: {
      handler(val) {
        this.groupInfoList = [];
        let index = 0;
        this.groupInfoList[index] = [];
        val.infoList.forEach(item => {
          if (item.isNewline) {
            index += 1;
            this.groupInfoList[index] = [];
            this.groupInfoList[index].push(item);
          } else {
            this.groupInfoList[index].push(item);
          }
        });
      },
      immediate: true
    }
  },
  mounted() {},

  methods: {
    handleAddModule() {
      this.$emit("onAdd");
    },
    // 模块更多操作
    handleMore(command, data) {
      if (command === "copy") {
        const moduleData = JSON.parse(JSON.stringify(this.moduleData));
        this.$emit("onCopy", moduleData);
      }
    },
    // 模块删除
    handleDeleteModule() {
      this.$emit("onDelete");
    },
    // 标题编辑
    handleTitleChange(title) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.title = title;
      this.$emit("onChange", moduleData);
    },
    handleSortInfo() {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.infoList = this.groupInfoList.flat();
      this.$emit("onChange", moduleData);
    },
    // info编辑
    handleInfoChange(key, data) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const dataIndex = moduleData.infoList.findIndex(item => item.key === key) || 0;
      console.log(dataIndex);
      moduleData.infoList.splice(dataIndex, 1, data);
      console.log(moduleData.infoList);
      this.$emit("onChange", moduleData);
    },
    // info添加
    handleAddInfo(key) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const dataIndex = moduleData.infoList.findIndex(item => item.key === key) || 0;
      moduleData.infoList.splice(dataIndex + 1, 0, {
        key: Math.random().toString(16),
        title: "",
        content: ""
      });
      this.$emit("onChange", moduleData);
    },
    // info删除
    handleDeleteInfo(key) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const dataIndex = moduleData.infoList.findIndex(item => item.key === key) || 0;
      moduleData.infoList.splice(dataIndex, 1);
      this.$emit("onChange", moduleData);
    }
  }
};
</script>

<style lang="less" scoped>
.character-info {
  .is-newline {
    width: 100%;
    height: 0;
  }

  .container {
    padding: 11px 10px 0;
  }
  .group-container {
    display: flex;
    flex-wrap: wrap;
    gap: 0 10px;
    .item-box {
      margin-bottom: 15px;
    }
  }
}

.add-btn {
  width: 20px;
  height: 20px;
  color: #ffffff;
  border-radius: 4px;
  margin-left: 3px;
  border: none;
  vertical-align: middle;
  line-height: 20px;
  text-align: center;
  margin-bottom: 15px;
  &:hover {
    opacity: 0.9;
  }
  .icon {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
</style>
